 const isInt = (value) =>
 	value !== null && value !== '' && typeof value !== 'boolean' && Number.isInteger(Number(value));
 const isStr = (value) => typeof value === 'string' && value.length > 0;

const SCHEMA = {
	logo1: { name: isStr, url: isStr, width: isInt, height: isInt, top: isInt, left: isInt, percentage: isInt },
	logo2: { name: isStr, url: isStr, width: isInt, height: isInt, top: isInt, right: isInt, percentage: isInt },
	banner: { name: isStr, url: isStr, width: isInt, height: isInt },
	background: { name: isStr, url: isStr, width: isInt, height: isInt },
};

/**
 * Validates a loaded `mb-compose-settings.json` file. Unknown top-level keys and
 * missing/invalid fields both make the file invalid.
 */
export default function validateComposeSettings(obj) {
	if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false;

	return Object.entries(obj).every(([key, value]) => {
		const rules = SCHEMA[key];
		if (!rules) return false;
		if (!value || typeof value !== 'object') return false;
		return Object.entries(rules).every(([field, check]) => check(value[field]));
	});
}
